/**
 * @type {{
 *  '0': string; '1': string; '2': string; '3': string; '4': string; '5': string; '6': string; '7': string;
 *  h0: string; h1: string; h2: string; h3: string; h4: string; h5: string; h6: string; h7: string;
 * }}
 */
export const fontSizes = { // L1
    "0": "36px",
    "1": "27px",
    "2": "20px",
    "3": "16px",
    "4": "14px",
    "5": "12px",
    "6": "10px",
    "7": "8px",
    get h0() { return this["0"]; },
    get h1() { return this["1"]; },
    get h2() { return this["2"]; },
    get h3() { return this["3"]; },
    get h4() { return this["4"]; },
    get h5() { return this["5"]; },
    get h6() { return this["6"]; },
    get h7() { return this["7"]; }
};

/*

NOTES

[L1]
Below is a WIP mapping of font size keys as they relate to what may
become the official design tokens defined by Worldpay.

value | how to use it in a styled-component
---------------------------------------------------------------------------
0     | font-size: ${({ theme }) => theme.headerFontSize.large.value};
1     | font-size: ${({ theme }) => theme.headerFontSize.medium.value};
2     | font-size: ${({ theme }) => theme.headerFontSize.regular.value};
3     | font-size: ${({ theme }) => theme.bodyFontSize.extra_large.value};
4     | font-size: ${({ theme }) => theme.bodyFontSize.large.value};
5     | font-size: ${({ theme }) => theme.bodyFontSize.medium.value};
6     | font-size: ${({ theme }) => theme.bodyFontSize.small.value};
7     | font-size: ${({ theme }) => theme.bodyFontSize.extra_small.value};

*/
